import PropTypes from 'prop-types';
import React from 'react';
import { Body1Stronger, Button, Card, CardFooter, CardHeader, Divider, mergeClasses } from '@fluentui/react-components';

import { useStyles } from './styles';

export const RecommendationTile = ({
  i18n,
  isReadOnly,
  onClick,
}) => {
  const styles = useStyles();

  return (
    <Card className={mergeClasses('auto-goal-entry-card', styles.card)}>
      <CardHeader
        header={
          <h2 className={styles.header} style={{ margin: 0 }}>
            {i18n.getString(_TL_('Add more conversion goals'))}
          </h2>
        }
      />
      <Divider />
      <Body1Stronger>
        {i18n.getString(_TL_('We have detected new conversion goals to add based on your website activities'))}
      </Body1Stronger>
      <p className={styles.text}>
        {i18n.getString(_TL_('Add more goals to further optimize your campaign performance.'))}
      </p>
      <CardFooter>
        <Button onClick={onClick} disabled={isReadOnly}>
          {i18n.getString(_TL_('See more'))}
        </Button>
      </CardFooter>
    </Card>
  );
};

RecommendationTile.propTypes = {
  onClick: PropTypes.func.isRequired,
  i18n: PropTypes.shape({ getString: PropTypes.func }).isRequired,
  isReadOnly: PropTypes.bool,
};

RecommendationTile.defaultProps = {
  isReadOnly: false,
};
